module.exports = "/images/template-editor-icon-light.svg?8b5f16a4f545e92f6b2ef75a0f9c63dc";